<div class="fuse-delete-modal dialog-content-wrapper">
  <div class="unsave-header">
    {{titleMessage | translate}}
  </div>
  <div mat-dialog-content class="m-0">
    <p class="unsave-data-text">
      <mat-icon>info</mat-icon>
      <span>{{confirmMessage | translate}}</span>
    </p>
  </div>

  @if (titleMessage !== 'send_mail_to_parent' && titleMessage !== 'new_recommendation') {
    <div
      mat-dialog-actions class="m-0 p-10" fxLayout="row" fxLayoutAlign="space-between center" class="unsave-footer">
      <button mat-button (click)="dialogRef.close(true)">{{'button.confirm' | translate}}</button>
      <button mat-button (click)="dialogRef.close(false)">{{'button.cancel' | translate}}</button>
    </div>
  }
  @if (titleMessage === 'send_mail_to_parent') {
    <div
      mat-dialog-actions class="m-0 p-10" fxLayout="row" fxLayoutAlign="space-between center" class="unsave-footer">
      <button mat-button (click)="dialogRef.close(true)">{{'yes' | translate}}</button>
      <button mat-button (click)="dialogRef.close(false)">{{'no' | translate}}</button>
    </div>
  }
  @if (titleMessage === 'new_recommendation') {
    <div
      mat-dialog-actions class="m-0 p-10" fxLayout="row" fxLayoutAlign="space-between center" class="unsave-footer">
      <button mat-button (click)="dialogRef.close(true)">{{'go_to_recommendation' | translate}}</button>
      <button mat-button (click)="dialogRef.close(false)">{{'OK' | translate}}</button>
    </div>
  }
</div>
